<template>
  <div class="c-outreach-launchpad-table-empty-state">
    <QIcon
      class="c-outreach-launchpad-table-empty-state__icon"
      name="ion-information-circle"
      size="28px"
    />
    <slot
      class="c-outreach-launchpad-table-empty-state__message"
      name="message"
    >
      {{ message }}
    </slot>
  </div>
</template>

<script>
import { getLocaleText } from "shared/boot/i18n";

export default {
  name: "OutreachLaunchpadTableEmptyState",
  props: {
    message: {
      type: String,
      default: () =>
        getLocaleText("outreach_launchpad_table_empty_state.default_message"),
    },
  },
};
</script>

<style lang="scss" scoped>
.c-outreach-launchpad-table-empty-state {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  &__icon {
    margin-bottom: 12px;
    color: var(--s-icons-empty-state);
  }

  &__message {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 130%;
    text-align: center;
    color: $ds-denim-9;
  }
}
</style>
